import React, { createContext, useState, useContext, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializeAuth = () => {
      const storedToken = localStorage.getItem('token');
      if (storedToken) {
        try {
          const decodedToken = jwtDecode(storedToken);
          setToken(storedToken);
          setUser(decodedToken);
          
          // Set userRole based on URLs in localStorage or token info
          const lastPath = localStorage.getItem('lastPath') || '';
          if (lastPath.includes('recruiter')) {
            setUserRole('recruiter');
          } else if (lastPath.includes('university')) {
            setUserRole('universitypartner');
          } else {
            setUserRole(decodedToken.userRole || 'user');
          }
        } catch (error) {
          console.error('Error decoding token:', error);
          localStorage.removeItem('token');
          setToken(null);
          setUser(null);
          setUserRole(null);
        }
      }
      setLoading(false);
    };

    initializeAuth();
  }, []);

  const login = (newToken, userData, role) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
    setUser(userData);
    setUserRole(role);
    
    // Store role-based path info
    if (role === 'recruiter') {
      localStorage.setItem('lastPath', '/recruiter/dashboard');
    } else if (role === 'universitypartner') {
      localStorage.setItem('lastPath', '/university/dashboard');
    } else {
      localStorage.setItem('lastPath', '/dashboard');
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('lastPath');
    setToken(null);
    setUser(null);
    setUserRole(null);
  };

  return (
    <AuthContext.Provider value={{ token, user, userRole, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}; 